import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { Box, Grid, Stack, styled } from '@mui/material';
import {
  CardVariant,
  Item,
  SmtpSetupConfigIcon,
  WsButton,
  WsCard,
  WsColors,
  WsDataTable,
  WsIconText,
} from 'wisestep-base';

type AccountProps = {
  account_name: string;
};

type tableProps = {
  accName: string;
  data: AccountProps[];
  columns?: any;
  icon: any;
  buttonCallBack(): void;
  deleteAccount(index: number): void;
};
const StyledStack = styled(Stack)({
  backgroundColor: WsColors.TheBlues50,
  gap: 3,
});
const AccountConfiguration = ({ accName, data, columns, icon, buttonCallBack }: tableProps) => (
  <>
    {data.length === 0 ? (
      <Box width="100%">
        <WsCard
          cardType={CardVariant.WITH_OUT_BG}
          title={`No ${accName} Account`}
          description={`Sign in to one of your ${accName} accounts to`}
          middleComponent={<SmtpSetupConfigIcon />}
          isButton={true}
          buttonText={`Add ${accName} Account`}
          btnStartIcon={<AddOutlinedIcon />}
          onClick={() => buttonCallBack()}
        />
      </Box>
    ) : (
      <Grid item xs={12}>
        <StyledStack direction="row" justifyContent="space-between">
          <Item>
            <WsIconText icon={icon} text={`${accName} Accounts Added`} />
          </Item>
          <Item sx={{ display: 'flex', justifyContent: 'space-between', alignSelf: 'center' }}>
            <WsButton
              onClick={() => buttonCallBack()}
              variant="contained"
              size="medium"
              startIcon={<AddOutlinedIcon />}
            >
              {`Add ${accName} Account`}
            </WsButton>
          </Item>
        </StyledStack>
        <Stack>
          <WsDataTable
            columns={columns}
            data={data}
            totalDataItems={data.length}
            selectable={true}
            boldItems={['account_name']}
            preSelectedRows={[]}
            pageable={false}
          />
        </Stack>
      </Grid>
    )}
  </>
);

export default AccountConfiguration;
